

window.addEventListener('DOMContentLoaded', (e) => {
  
  let buttons = [...document.querySelectorAll('.button')];

  buttons.forEach(button => {
    
    let textEn = button.dataset.en;
    let textCn = button.dataset.cn;

    let innerHTML = `
    <div class="button__container">
      <span class="button__text button__text--en"> ${textEn} </span>
      <span class="button__text button__text--cn"> ${textCn} </span>
    </div>
    `;

    if (/Mobi|Android/i.test(navigator.userAgent)) {
      innerHTML = `
      <div class="button__container">
        <span class="button__text button__text--en"> ${textCn} </span>
      </div>
      `
    }

    button.innerHTML = innerHTML;
  });
})